export const requestPageTypes = {
    EmrgencyRequest: 1,
    Appointment: 2
}
export const treatmentTypes = {
    EMERGENCYREQUEST: 1,
    TREATMENTREQUEST: 2,
    APPOINMENTS: 3
}